function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 0;\n  display: block;\n  & a {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 9px;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "here"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "Invalid HTML tags were removed from the pasted content. Click ",
        " for supported HTML tags."
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "Working with white or light colored text? Use Dark mode."
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "More Fonts"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "This content contains one or more Custom Fields that no longer exist in your event. Please remove any invalid Custom Fields to continue."
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "The content contains invalid HTML tags. Please visit ",
        " for supported HTML tags."
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Custom"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Select custom color"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
import React, { useState } from "react";
import { t, c, jt } from "ttag";
import { Form, message, Switch } from "antd";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Renderer } from "@eventmobi/rich-text";
// @ts-ignore
import Editor, { TOOLBAR_BUTTONS } from "@eventmobi/rich-text/Editor";
// @ts-ignore
import { isValid as isValidHTML } from "@eventmobi/rich-text/html";
// @ts-ignore
import { hasValidFields } from "@eventmobi/rich-text/dynamicFields";
// @ts-ignore
import RichTextLinkStyles from "@eventmobi/rich-text/OverrideLinkStyles";
import { Icons } from "../IconPicker/Icons";
import useTranslation from "../../hooks/useTranslation";
import { getEventUrls } from "../../state/event";
import Emphasis from "../Emphasis";
import Fonts, { useFonts } from "../Fonts";
var ALLOWED_TOOLBAR_BUTTONS = [
    TOOLBAR_BUTTONS.BOLD,
    TOOLBAR_BUTTONS.ITALIC,
    TOOLBAR_BUTTONS.UNDERLINE,
    TOOLBAR_BUTTONS.COLOR,
    TOOLBAR_BUTTONS.ALIGN,
    TOOLBAR_BUTTONS.UL,
    TOOLBAR_BUTTONS.OL,
    TOOLBAR_BUTTONS.LINK,
    TOOLBAR_BUTTONS.UNLINK,
    TOOLBAR_BUTTONS.IMAGE,
    TOOLBAR_BUTTONS.ERASER,
    TOOLBAR_BUTTONS.SOURCE,
    TOOLBAR_BUTTONS.FONTSIZE,
    TOOLBAR_BUTTONS.FONT,
    TOOLBAR_BUTTONS.CUSTOM_FONTS
];
export var SUPPORT_PAGE_LINK_HTML_TAGS = "https://help.eventmobi.com/en/knowledge/what-html-tags-does-the-rich-text-editor-support#";
var Wrapper = styled.div(_templateObject(), function(props) {
    return props.$linkColor;
});
var Toggle = styled.div(_templateObject1());
var knowledgeBaseLink = /*#__PURE__*/ React.createElement("a", {
    href: SUPPORT_PAGE_LINK_HTML_TAGS,
    target: "_blank",
    rel: "noreferrer noopener"
}, c("As in: Click here to go the knowledge base support page.").t(_templateObject2()));
var onPasteError = function() {
    message.warning(jt(_templateObject3(), knowledgeBaseLink));
};
export var EditorWrapper = function(_param) {
    var eventId = _param.eventId, _param_onChange = _param.onChange, onChange = _param_onChange === void 0 ? function() {} : _param_onChange, linkColor = _param.linkColor, _param_allowDarkMode = _param.allowDarkMode, allowDarkMode = _param_allowDarkMode === void 0 ? true : _param_allowDarkMode, rest = _objectWithoutProperties(_param, [
        "eventId",
        "onChange",
        "linkColor",
        "allowDarkMode"
    ]);
    var language = useTranslation().language;
    var eventUrls = useSelector(getEventUrls);
    var _useFonts = useFonts(), isLibraryVisible = _useFonts.visible, fonts = _useFonts.fonts, updateFonts = _useFonts.updateFonts, setLibraryVisible = _useFonts.setVisible;
    var _useState = _slicedToArray(useState(false), 2), isDarkModeEnabled = _useState[0], setDarkModeEnabled = _useState[1];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, eventUrls && /*#__PURE__*/ React.createElement(RichTextLinkStyles, {
        icon: Icons.externalLink,
        color: linkColor,
        urls: eventUrls
    }), allowDarkMode && /*#__PURE__*/ React.createElement(Toggle, null, t(_templateObject4()), /*#__PURE__*/ React.createElement(Switch, {
        checked: isDarkModeEnabled,
        onChange: function() {
            return setDarkModeEnabled(function(prev) {
                return !prev;
            });
        }
    })), /*#__PURE__*/ React.createElement(Wrapper, {
        $linkColor: linkColor,
        className: "ant-input"
    }, /*#__PURE__*/ React.createElement(Editor, _extends({}, rest, {
        language: language,
        onPasteError: onPasteError,
        onChange: onChange,
        moreFontsLabel: t(_templateObject5()),
        customFonts: fonts,
        onAddFonts: function() {
            return setLibraryVisible(true);
        },
        isDarkMode: isDarkModeEnabled
    })), isLibraryVisible && /*#__PURE__*/ React.createElement(Fonts, {
        onSave: updateFonts,
        fonts: fonts,
        onClose: function() {
            return setLibraryVisible(false);
        }
    })));
};
export var DEFAULT_TOOLBAR_BUTTONS_TYPE = "DEFAULT";
export var WIDGET_DESIGNER_TOOLBAR_BUTTONS_TYPE = "WIDGET_DESIGNER";
export var BADGE_DESIGNER_TOOLBAR_BUTTONS_TYPE = "BADGE_DESIGNER";
export var BADGE_DESIGNER_SIMPLE_LABEL_TOOLBAR_BUTTONS_TYPE = "BADGE_DESIGNER_LABEL";
export var CONFIRMATION_EMAIL_TOOLBAR_BUTTONS_TYPE = "CONFIRMATION_EMAIL";
var _obj;
var TOOLBAR_BUTTONS_TYPE = (_obj = {}, _defineProperty(_obj, DEFAULT_TOOLBAR_BUTTONS_TYPE, [
    TOOLBAR_BUTTONS.CUSTOM_FONTS,
    TOOLBAR_BUTTONS.FONTSIZE,
    TOOLBAR_BUTTONS.BOLD,
    TOOLBAR_BUTTONS.ITALIC,
    TOOLBAR_BUTTONS.UNDERLINE,
    TOOLBAR_BUTTONS.COLOR,
    TOOLBAR_BUTTONS.ALIGN,
    TOOLBAR_BUTTONS.UL,
    TOOLBAR_BUTTONS.OL,
    TOOLBAR_BUTTONS.LINK,
    TOOLBAR_BUTTONS.UNLINK,
    TOOLBAR_BUTTONS.IMAGE,
    TOOLBAR_BUTTONS.ERASER,
    TOOLBAR_BUTTONS.SOURCE
]), _defineProperty(_obj, WIDGET_DESIGNER_TOOLBAR_BUTTONS_TYPE, [
    TOOLBAR_BUTTONS.CUSTOM_FONTS,
    TOOLBAR_BUTTONS.FONTSIZE,
    TOOLBAR_BUTTONS.BOLD,
    TOOLBAR_BUTTONS.ITALIC,
    TOOLBAR_BUTTONS.UNDERLINE,
    TOOLBAR_BUTTONS.COLOR,
    TOOLBAR_BUTTONS.ALIGN,
    TOOLBAR_BUTTONS.UL,
    TOOLBAR_BUTTONS.OL,
    TOOLBAR_BUTTONS.LINK,
    TOOLBAR_BUTTONS.UNLINK,
    TOOLBAR_BUTTONS.ERASER,
    TOOLBAR_BUTTONS.SOURCE
]), _defineProperty(_obj, BADGE_DESIGNER_TOOLBAR_BUTTONS_TYPE, [
    TOOLBAR_BUTTONS.CUSTOM_FONTS,
    TOOLBAR_BUTTONS.FONTSIZE,
    TOOLBAR_BUTTONS.BOLD,
    TOOLBAR_BUTTONS.ITALIC,
    TOOLBAR_BUTTONS.UNDERLINE,
    TOOLBAR_BUTTONS.COLOR,
    TOOLBAR_BUTTONS.ALIGN,
    TOOLBAR_BUTTONS.UL,
    TOOLBAR_BUTTONS.OL
]), _defineProperty(_obj, BADGE_DESIGNER_SIMPLE_LABEL_TOOLBAR_BUTTONS_TYPE, [
    TOOLBAR_BUTTONS.CUSTOM_FONTS,
    TOOLBAR_BUTTONS.FONTSIZE,
    TOOLBAR_BUTTONS.BOLD,
    TOOLBAR_BUTTONS.ITALIC,
    TOOLBAR_BUTTONS.UNDERLINE,
    TOOLBAR_BUTTONS.ALIGN,
    TOOLBAR_BUTTONS.UL,
    TOOLBAR_BUTTONS.OL
]), _defineProperty(_obj, CONFIRMATION_EMAIL_TOOLBAR_BUTTONS_TYPE, [
    TOOLBAR_BUTTONS.BOLD,
    TOOLBAR_BUTTONS.ITALIC,
    TOOLBAR_BUTTONS.UNDERLINE,
    TOOLBAR_BUTTONS.COLOR,
    TOOLBAR_BUTTONS.ALIGN,
    TOOLBAR_BUTTONS.UL,
    TOOLBAR_BUTTONS.OL,
    TOOLBAR_BUTTONS.LINK,
    TOOLBAR_BUTTONS.UNLINK
]), _obj);
var RichTextEditor = function(_param) {
    var rules = _param.rules, _param_infoText = _param.infoText, infoText = _param_infoText === void 0 ? "" : _param_infoText, eventId = _param.eventId, _param_showColor = _param.showColor, showColor = _param_showColor === void 0 ? true : _param_showColor, _param_buttonsType = _param.buttonsType, buttonsType = _param_buttonsType === void 0 ? DEFAULT_TOOLBAR_BUTTONS_TYPE : _param_buttonsType, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, name = _param.name, _param_dynamicFieldsOpts = _param.dynamicFieldsOpts, dynamicFieldsOpts = _param_dynamicFieldsOpts === void 0 ? undefined : _param_dynamicFieldsOpts, linkColor = _param.linkColor, _param_onChange = _param.onChange, onChange = _param_onChange === void 0 ? function() {} : _param_onChange, _param_allowDarkMode = _param.allowDarkMode, allowDarkMode = _param_allowDarkMode === void 0 ? true : _param_allowDarkMode, rest = _objectWithoutProperties(_param, [
        "rules",
        "infoText",
        "eventId",
        "showColor",
        "buttonsType",
        "disabled",
        "name",
        "dynamicFieldsOpts",
        "linkColor",
        "onChange",
        "allowDarkMode"
    ]);
    var checkValidation = function() {
        var _ref = _asyncToGenerator(function(_, value) {
            var _dynamicFieldsOpts_fields;
            return __generator(this, function(_state) {
                if ((dynamicFieldsOpts === null || dynamicFieldsOpts === void 0 ? void 0 : (_dynamicFieldsOpts_fields = dynamicFieldsOpts.fields) === null || _dynamicFieldsOpts_fields === void 0 ? void 0 : _dynamicFieldsOpts_fields.length) > 0 && !hasValidFields(value, dynamicFieldsOpts.fields)) {
                    throw new Error(t(_templateObject6()));
                }
                if (!isValidHTML(value)) {
                    throw new Error(// @ts-ignore Ignoring this because the error is actually rendered as a React tag
                    jt(_templateObject7(), SUPPORT_PAGE_LINK_HTML_TAGS));
                }
                return [
                    2
                ];
            });
        });
        return function checkValidation(_, value) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Form.Item, _extends({}, rest, {
        name: name,
        rules: [
            {
                validator: checkValidation,
                validateTrigger: "onSubmit"
            }
        ].concat(_toConsumableArray(rules || [])),
        style: {
            marginBottom: 0
        }
    }), /*#__PURE__*/ React.createElement(EditorWrapper, {
        id: "".concat(name, "-RTE"),
        readOnly: disabled,
        eventId: eventId,
        showColor: showColor,
        colorPickerLocale: {
            button: t(_templateObject8()),
            title: t(_templateObject9())
        },
        buttons: TOOLBAR_BUTTONS_TYPE[buttonsType],
        dynamicFieldsOpts: dynamicFieldsOpts,
        linkColor: linkColor,
        onChange: onChange,
        allowDarkMode: allowDarkMode
    })), infoText && /*#__PURE__*/ React.createElement(Emphasis, null, infoText));
};
export { Renderer as RichTextRenderer };
export default RichTextEditor;
